import React from "react";

/**
 * SunSpinner - Animated loading indicator using the Solar-Green sun logo.
 * size: "sm" | "md" | "lg"
 */
export default function SunSpinner({ size = "md", text = "" }) {
    const dim = size === "sm" ? 24 : size === "lg" ? 56 : 36;
    return (
        <div className="flex flex-col items-center justify-center gap-2" data-testid="sun-spinner">
            <svg width={dim} height={dim} viewBox="0 0 100 100" className="animate-spin" style={{ animationDuration: "2.5s" }}>
                {/* Rays */}
                {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
                    <polygon
                        key={i}
                        points="50,8 44,22 56,22"
                        fill="#F0C800"
                        transform={`rotate(${angle} 50 50)`}
                    />
                ))}
                {/* Outer ring */}
                <circle cx="50" cy="50" r="24" fill="none" stroke="#333" strokeWidth="4" />
                {/* Inner sun */}
                <circle cx="50" cy="50" r="20" fill="#F9D932" />
            </svg>
            {text && <p className="text-xs text-gray-400 font-medium">{text}</p>}
        </div>
    );
}


/**
 * PageLoader - Wraps page content with loading state.
 * Shows sun spinner over content area, keeping navbar/footer visible.
 */
export function PageLoader({ loading, children }) {
    if (loading) {
        return (
            <div className="flex items-center justify-center py-24" data-testid="page-loader">
                <SunSpinner size="lg" text="Nacitam..." />
            </div>
        );
    }
    return children;
}
